import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=1a03fd9a&scoped=true&"
import script from "./BottomMenu.vue?vue&type=script&lang=js&"
export * from "./BottomMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=1a03fd9a&scoped=true&lang=scss&"
import style1 from "./BottomMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03fd9a",
  null
  
)

export default component.exports